import { createContext } from 'react';
import type {
  SatelliteConversationFolderTypeV2,
  SatelliteConversationReadRepliedStatusTypeV2,
  SatelliteConversationRenterProgressStatusTypeV2,
} from '@zg-rentals/ts-satellite-client';
import type { InboxPageMobileView } from '../types/InboxPageMobileView';

type ContextProps = {
  clientTimeZone: string;
  conversationId?: string;
  daysBack?: number;
  folder: SatelliteConversationFolderTypeV2;
  isByProperty: boolean;
  isTimeZoneForced: boolean;
  listingAlias?: string;
  mobileView: InboxPageMobileView;
  readRepliedStatus: SatelliteConversationReadRepliedStatusTypeV2;
  renterProgressStatus: SatelliteConversationRenterProgressStatusTypeV2;
};

export const InboxPageContext = createContext<ContextProps>({} as ContextProps);
export const InboxPageContextProvider = InboxPageContext.Provider;
